import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import {withNamespaces} from "react-i18next";
import PopupComponent from "../../common/components/Popup/Popup.component";
import LoadingComponent from "../../forms/components/LoadingComponent/LoadingComponent";
import PtCancellationService from "../services/PtCancellationService";

// One confirm screen: no reason, no save offers, no payment. The request is always accepted, so
// the only outcomes are "cancelled" and "submitted, the club will finish it".
const PtCancellationProcessComponent = (props) => {
  const {t} = props;
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  useEffect(() => {
    setLoading(true);
    PtCancellationService.getDetails()
      .then(data => {
        if (data.eligible) {
          setDetails(data);
        } else {
          setError(t([`pt_cancellation_${data.error}_error`, 'pt_cancellation_unknown_error']));
        }
      })
      .catch(() => setError(t('pt_cancellation_unknown_error')))
      .finally(() => setLoading(false));
  }, []);

  const submit = () => {
    setLoading(true);
    setError(null);
    PtCancellationService.submit()
      .then(setResult)
      .catch(err => setError(t([`pt_cancellation_${err.error}_error`, 'pt_cancellation_unknown_error'])))
      .finally(() => setLoading(false));
  };

  const close = () => {
    props.onEnd(!!result);
  };

  const header = result ? t('pt_cancellation_success_header') : t('pt_cancellation_header');

  return (
    <PopupComponent header={header}
                    popupClasses={'cancellation-popup pt-cancellation-popup'}
                    onClose={close}
                    buttons={
                      result || error ? (
                        <button className='form-main-button' onClick={close}>{t('pt_cancellation_close')}</button>
                      ) : (
                        <React.Fragment>
                          <button className='form-main-button white-with-border close-button' onClick={close}>
                            {t('pt_cancellation_keep')}
                          </button>
                          <button className='form-main-button next-button' onClick={submit} disabled={!details}>
                            {t('pt_cancellation_confirm')}
                          </button>
                        </React.Fragment>
                      )
                    }>
      {loading && <LoadingComponent isVisible={loading}/>}

      {result ? (
        <div className='cancellation-confirmation-container'>
          <div className='cancellation-confirmation-header'>
            <i className='fa fa-check-circle-o'/>
            <h3>{t('pt_cancellation_success_header')}</h3>
            <p>{t(result.complete ? 'pt_cancellation_success_text' : 'pt_cancellation_pending_text')}</p>
          </div>
        </div>
      ) : (
        !error && details && (
          <div className='pt-cancellation-confirm'>
            <p>{t('pt_cancellation_intro', {count: (details.services || []).length})}</p>
            {details.services && details.services.length > 0 && (
              <ul className='pt-cancellation-services'>
                {details.services.map(service => (
                  <li key={service.id}>{service.name}</li>
                ))}
              </ul>
            )}
          </div>
        )
      )}

      {error && <p className='error-text mt-16'>{error}</p>}
    </PopupComponent>
  );
};

PtCancellationProcessComponent.propTypes = {
  t: PropTypes.func.isRequired,
  onEnd: PropTypes.func.isRequired,
};

export default withNamespaces()(PtCancellationProcessComponent);
